import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CookieService } from 'ngx-cookie';
import { FormDoneService } from '../../_services/form-done.service';
import { AuthenticationService } from './../../_services/index';
import { Subscription } from 'rxjs/Subscription';
import { AuthService } from 'angular4-social-login';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  providers: [FormDoneService, AuthenticationService]
})
export class HeaderComponent implements OnInit, OnDestroy {
  currentUser: any;
  firstname;
  lastname;
  firstletter;
  lastletter;
  logoUrl = 'assets/img/logo.png';
  public loginFlag = false;
  public domainFlag = false;
  public domains: any[] = [];
  public getHeaderDataSub: Subscription;
  public addStudentPartnerSub: Subscription;

  constructor(private router: Router,
    private authService: AuthService,
    private _cookieService: CookieService,
    private formapi: FormDoneService,
    private loginservice: AuthenticationService,
  ) {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    console.log(this.currentUser);
    console.log( localStorage.getItem('currentUser') );
    if (localStorage.getItem('currentUser') != null) {
      this.loginFlag = true;
      this.firstname = this.currentUser.firstname;
      this.lastname = this.currentUser.lastname;

      this.firstletter = this.firstname.charAt(0).toUpperCase();
      this.lastletter = this.lastname.charAt(0).toUpperCase();

    }
  }

  ngOnInit() {
    this.getHeaderData();
  }

  signout() {

    //this.authService.signOut();
    localStorage.removeItem('currentUser');
    localStorage.removeItem('token');
    const getDomainName = this.loginservice.getDomainName();
    const parts = window.location.hostname.split(getDomainName);

    const countLength = parts.length;

    const subdomain = parts.shift();
    if (countLength === 1)  {
      this._cookieService.remove('token', {
        domain: getDomainName,
      });
    }
    if (countLength === 2) {
      this._cookieService.remove('token', {
        domain: getDomainName,
      });
    }
    if (localStorage.removeItem('currentUser') == null) {
      this.router.navigate(['/login']);
    }
    this.router.navigate(['/login']);
  }

  getHeaderData() {
    const getDomainName = this.loginservice.getDomainName();
    const parts = window.location.hostname.split(getDomainName);
    const countLength = parts.length;
    const subdomain = parts.shift();

    if (countLength === 2) {
      this.getHeaderDataSub = this.formapi.getHeaderData$(subdomain).subscribe(
        response => {
          const headerData = response.data;
          console.log(response.data);
          if (headerData.statusCode !== 400) {
            this.domainFlag = false;
            this.addStudentPartner(headerData.id);
            this.logoUrl = headerData.logo.full_path;

          } else {
            this.showInvalidDomain();
          }
        },
        error => {
          console.log(error);
          this.showInvalidDomain();
        }
      );
    } else {
      this.showInvalidDomain();
    }
  }
  showInvalidDomain() {
    this.domainFlag = true;

    this.formapi.getDomainList$().subscribe(
      response => {
        console.log(response);
        this.domains = response;
      },
      error => {
        console.log(error);
      }
    );
  }

  addStudentPartner(id) {

    const authResult = localStorage.getItem('token');

    if (authResult) {
      const body = JSON.stringify({
        partnerid: id
      });
      this.addStudentPartnerSub = this.loginservice.addStudentPartner$(body).subscribe(
        (dataResponse) => {
          console.log(dataResponse);
        },
        error => {
          console.log(error);
        }
      );
    }
  }

  ngOnDestroy() {
    if (this.getHeaderDataSub)  {
      this.getHeaderDataSub.unsubscribe();
    }
    if (this.addStudentPartnerSub) {
      this.addStudentPartnerSub.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/pages/header/header.component.ts